import { type LinkProps } from '@tanstack/react-router';
import { CaretLeft } from '@phosphor-icons/react';
import { css } from 'styled-system/css';
import { Lockup } from '@/design-system';
import { BackLink } from './BackLink';

export interface BackHeaderProps {
  readonly to?: LinkProps['to'];
}

const row = css({ display: 'flex', alignItems: 'center', gap: '10px' });
const back = css({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  flex: 'none',
  fontFamily: 'wsUi',
  fontSize: '15px',
  fontWeight: 'bold',
  color: 'ws.jadeInk',
  textDecoration: 'none',
  borderRadius: '999px',
  padding: '6px 12px 6px 8px',
  bg: 'ws.glass',
  boxShadow: '0 1px 2px rgba(33,75,64,0.08)',
  _hover: { bg: 'ws.glassHover' },
  _focusVisible: { outline: '3px solid token(colors.ws.sakuraRose)', outlineOffset: '2px' },
});
// Desktop clusters Retour + Lockup on the left (like the play header); phone keeps the lockup pinned right.
const spacer = css({ flex: 1, lg: { flex: '0 0 10px' } });

export function BackHeader({ to = '/' }: BackHeaderProps = {}) {
  return (
    <div className={row}>
      <BackLink to={to} className={back}>
        <CaretLeft size={16} weight="bold" aria-hidden="true" />
        Retour
      </BackLink>
      <span className={spacer} />
      <Lockup orientation="horizontal" tone="jade" iconSize={24} textSize={17} gap={7} />
    </div>
  );
}
